import { SELECTORS } from '../utils/constants';
import {
  shouldShowWarrantyAtcModal,
  openWarrantyAtcModal,
  executeAddToCart,
} from './product-warranty-atc-modal';

const setBtnLoadingState = (button, spinner, loading) => {
  if (!button) return;
  button.classList.toggle('pointer-events-none', loading);
  button.classList.toggle('opacity-50', loading);
  if (spinner) spinner.classList.toggle('hidden', !loading);
};

const getItem = form => {
  const variantId = +form.id.value;
  const quantity = +form.elements['quantity'].value;

  const sellingPlanEl = form.elements['selling_plan'];
  const sellingPlan = sellingPlanEl && sellingPlanEl.value !== '' ? +sellingPlanEl.value : null;

  return [variantId, quantity, sellingPlan];
};

const initAtcForm = () => {
  const atcForms = document.querySelectorAll('[data-product-form]');
  if (!atcForms.length) return;

  const addVariantToCart = async evt => {
    evt.preventDefault();
    const submitBtnSpinner = evt.submitter?.querySelector(SELECTORS.LOADING_SPINNER);
    setBtnLoadingState(evt.submitter, submitBtnSpinner, true);

    try {
      const [variantId, quantity, sellingPlan] = getItem(evt.target);

      if (await shouldShowWarrantyAtcModal()) {
        setBtnLoadingState(evt.submitter, submitBtnSpinner, false);
        openWarrantyAtcModal({
          form: evt.target,
          variantId,
          quantity,
          sellingPlan,
          submitter: evt.submitter,
          spinner: submitBtnSpinner,
        });
        return;
      }

      await executeAddToCart({
        form: evt.target,
        variantId,
        quantity,
        sellingPlan,
        submitter: evt.submitter,
        spinner: submitBtnSpinner,
      });
    } catch (error) {
      console.error('Error adding variant to cart:', error);
    } finally {
      setBtnLoadingState(evt.submitter, submitBtnSpinner, false);
    }
  };

  atcForms.forEach(form => {
    form.addEventListener('submit', addVariantToCart);
  });
};

export default initAtcForm;
